module.exports = __webpack_public_path__ + "static/media/arrow--bottom--violet.6e0b8f1f.svg";